<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">基本配置</div>
          <div class="card-body">
            <Alert>
              重要说明
              <template slot="desc">
                网站地址必须填写http://或https://+您的网站域名。例:http://mall.h234.cn<br />
                前台浏览器标题及SEO内容修改教程：<a href="https://www.kancloud.cn/osuu234/geek-shop/2287814" target="_blank"
                  style="color: rgb(87, 163, 243)">点此查看</a>
              </template>
            </Alert>

            <Form ref="create" :model="formValidate" :label-width="140">
              <FormItem label="网站名称" prop="web_name">
                <Input v-model="formValidate.web_name" placeholder="请输入网站名称"></Input>
              </FormItem>
              <FormItem label="网站地址" prop="web_url">
                <Input v-model="formValidate.web_url" placeholder="请输入网站地址"></Input>
              </FormItem>
              <FormItem label="网站LOGO" prop="web_logo">
                <div class="pictrueBox">
                  <div class="pictrue" v-if="formValidate.web_logo" @click="upload()">
                    <img :src="formValidate.web_logo" alt="" />
                  </div>
                  <div class="upload" @click="upload()" v-else>
                    <Icon type="ios-camera" size="20"></Icon>
                  </div>
                </div>
              </FormItem>
              <FormItem label="底部版权" prop="copy">
                <Input v-model="formValidate.copy" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入底部版权,支持HTML"></Input>
              </FormItem>
              <FormItem label="友情链接" prop="link">
                <Input v-model="formValidate.link" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
                  placeholder="请输入友情链接,支持HTML"></Input>
              </FormItem>
              <FormItem label="联系客服跳转地址" prop="copy">
                <Input v-model="formValidate.help_qq" placeholder="请输入跳转地址"></Input>

                <p style="font-size: 12px; color: #999">
                  * 跳转QQ请输入 http://wpa.qq.com/msgrd?v=3&uin=您的QQ号码&site=qq&menu=yes
                </p>
              </FormItem>
              <FormItem label="手机端顶部客服弹窗" prop="help_content">
                <Input v-model="formValidate.help_content" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
                  placeholder="请输入顶部客服弹窗内容"></Input>
              </FormItem>
              <FormItem label="网站公告" prop="announce">
                <Input v-model="formValidate.announce" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
                  placeholder="请输入网站公告"></Input>
              </FormItem>

              <FormItem label="库存不足预警" prop="stock_warning">
                <i-switch v-model="formValidate.stock_warning" :true-value="'1'" :false-value="'0'" />
                <p style="font-size: 12px; color: #999">
                  * 库存不足邮件通知管理员
                </p>
              </FormItem>
              <FormItem label="库存不足预警额度" prop="stock_warning_count" v-show="formValidate.stock_warning == 1">
                <InputNumber :min="0" :step="0.01" v-model="formValidate.stock_warning_count"></InputNumber>
                <p style="font-size: 12px; color: #999">
                  * 库存不足多少件时通知管理员
                </p>
              </FormItem>
              <FormItem label="商品出售提醒" prop="stock_reminder">
                <i-switch v-model="formValidate.stock_reminder" :true-value="'1'" :false-value="'0'" />
                <p style="font-size: 12px; color: #999">
                  * 库存不足邮件通知管理员
                </p>
              </FormItem>

              <FormItem>
                <Button type="primary" @click="editSave" :loading="creating">保存</Button>
              </FormItem>
            </Form>

          </div>
        </div>
      </div>
    </div>
    <UploadPictures @use="use"></UploadPictures>

  </div>
</template>

<script>
  import {
    getSystem,
    putSystem
  } from "@/api/admin";
  export default {
    data() {
      return {
        formValidate: {
          mobileHeadBg: "",
          pcHeadBg: "",
          tabbar_active_color: "",
        },
        creating: false,
      };
    },
    created() {
      this._getData();
    },

    methods: {
      // 调用上传组件
      upload() {
        this.$store.state.imgUsageType = 1;
        this.$store.state.showBase = true;
      },
      // 使用图片传值
      use(val) {
        let long = val.length;
        if (long == 1) {
          this.formValidate.web_logo = val[0];
          this.$store.state.showBase = false;
        } else {
          this.$Message.warning({
            background: true,
            content: "最多选择1张图片",
          });
        }

      },
      // 获取列表
      _getData() {
        getSystem("basic").then((res) => {
          this.formValidate = res.data;
        });
      },
      // 保存修改
      editSave() {
        this.creating = true;
        putSystem({
          createData: this.formValidate,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.creating = false;
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .pictrueBox {
    display: block;

    .upload {
      display: inline-block;
      margin-right: 10px;
      width: 180px;
      height: 60px;
      line-height: 60px;
      border: 1px dotted rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.02);
      cursor: pointer;
      text-align: center;
    }

    .pictrue {
      width: 180px;
      height: 60px;
      display: inline-block;
      margin-right: 15px;
      vertical-align: middle;
      background: rgba(0, 0, 0, 0.02);
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        border-radius: 4px;
      }

      .ivu-btn {
        position: absolute;
        font-size: 12px !important;
        width: 20px;
        height: 20px;
        top: -6px;
        right: -6px;
      }
    }
  }

  .ivu-tabs {
    overflow: visible;
  }
</style>